import { useCallback, useState } from 'react';

import { IHeaderParams } from 'ag-grid-community';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';

import {
  useInvalidateFreezeQueries,
  useUpdateInterimEmbryoTransaction,
} from '../../../services/freeze/hooks';
import { FIELD_NAMES } from '../utils/constants';

export const CheckboxHeader = (props: IHeaderParams) => {
  const [checked, setChecked] = useState(() => {
    let allChecked = true;
    props.api.forEachNode((row) => {
      if (!row.data?.tt) {
        allChecked = false;
      }
    });
    return allChecked;
  });

  const { mutateAsync: updateIntEmbryo } = useUpdateInterimEmbryoTransaction();
  const { invalidateFertilizationList, invalidateFertAndEmbryos } =
    useInvalidateFreezeQueries();

  const onCheckboxChange = useCallback(
    (e: CheckboxChangeEvent) => {
      setChecked(e.checked as boolean);

      const api = props.api;
      const updates: any[] = [];

      api.forEachNode?.((row) => {
        if (row.data?.stage && row.data?.grade) {
          updates.push({
            ...row.data,
            embryoFreezeEntryId: row.data.embryoFreezeEntryId,
            tt: e.checked,
          });

          updateIntEmbryo({
            id: row.data.embryoFreezeEntryId,
            field: FIELD_NAMES.TT,
            value: (e.checked as boolean).toString(),
          });
        }
      });

      api.applyTransaction({
        update: updates,
      });
      invalidateFertilizationList();
      invalidateFertAndEmbryos();
    },
    [
      props.api,
      updateIntEmbryo,
      invalidateFertilizationList,
      invalidateFertAndEmbryos,
    ],
  );

  return (
    <div className="ag-header-cell-label freeze-tt__checkbox-header">
      <span className="ag-header-cell-text">T/T</span>
      <Checkbox
        checked={checked}
        onChange={onCheckboxChange}
        tooltip="Stage and grade required"
      />
    </div>
  );
};
